// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { tippyStyles } from "@west/App/Components/Tippy/Tippy";
import { color, getSystemColor } from "@west/XDL/Utilities";
import { css } from "styled-components";

const tippyArrow = css`
    .tippy-arrow {
        &,
        &::before {
            position: absolute;
            width: 24px;
            height: 24px;
            z-index: 1;
        }

        &::before {
            content: "";
            background: ${getSystemColor("common.white")};
            border-color: ${getSystemColor("common.border")};
            border-style: solid;
            border-width: 0 1px 1px 0;
            border-radius: 0 0 4px 0;
        }
    }

    &[data-placement^="top"] > .tippy-arrow {
        bottom: -10px;
        &:before {
            transform: scale(0.8, 0.8) rotate(45deg);
        }
    }

    &[data-placement^="bottom"] > .tippy-arrow {
        top: -24px;
        &:before {
            transform: scale(0.8, 0.8) rotate(-135deg);
        }
    }

    &[data-placement^="left"] > .tippy-arrow {
        right: -10px;
        &:before {
            transform: scale(0.8, 0.8) rotate(-45deg);
        }
    }

    &[data-placement^="right"] > .tippy-arrow {
        left: -10px;
        &:before {
            transform: scale(0.8, 0.8) rotate(135deg);
        }
    }
`;

tippyStyles.container = {
    css: css`
        &.tippy-box {
            color: ${color("text.main")};
            background-color: ${color("common.white")};
            border: 1px solid ${color("common.border")};
            border-radius: 0;
            box-shadow: none;
            min-width: 200px;

            & > .tippy-content {
                padding: 14px;
            }
        }

        &&&.tippy-box {
            ${tippyArrow}
        }
    `,
};
